import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class InfoApi {
    
    static getPreguntasFrecuentes() {
        
         return $.ajax({
			url: getLocacion()+ "/info/preguntas/",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    static getInstructores(id) {
        
         return $.ajax({
			url: getLocacion()+ "/info/instructores/"+id,
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    static getStaff() {
        
         return $.ajax({
			url: getLocacion()+ "/info/staff/",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
     static getHomeInfo() {
        
         return $.ajax({
			url: getLocacion()+ "/info/home",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    static getCursosGratuitos() {
        
         return $.ajax({
			url: getLocacion()+ "/info/cursosgratuitos",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCursosConstancias() {
        
         return $.ajax({
			url: getLocacion()+ "/info/cursosCosntancias/",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCursosCarrusel() {
        
         return $.ajax({
			url: getLocacion()+ "/info/cursos",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    
       static getInsigniaInfo() {
        
         return $.ajax({
			url: getLocacion()+ "/info/insigniainfo",
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    static getCursoDetalle(id) {
        
         return $.ajax({
			url: getLocacion()+ "/info/curso/detalle/"+id,
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
    }
    
    static getCursoDetalleInfo(id) {
        
         return $.ajax({
			url: getLocacion()+ "/info/cursoInfo/"+id,
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
    }
    
    
     static getCursoDetalleUsuario(idCurso, idUsuario) {
        
         return $.ajax({
			url: getLocacion()+ "/info/cursoUsuario?idCurso="+idCurso+"&idUsuario="+idUsuario,
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    
    static getCursoOpinion(id) {
        
         return $.ajax({
			url: getLocacion()+ "/info/opiniones/"+id,
			  statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    static getInfo(paginaInfo) {
        
       let paginaInfoEnvio = Object.assign({}, paginaInfo);
		let comando="POST";
		 
		paginaInfoEnvio=JSON.stringify(paginaInfoEnvio);
		return $.ajax({
			url: getLocacion()+ "/info/pagina",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: paginaInfoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}  
    
    
     static validaDatos(constancia) {
        
       let constanciaEnvio = Object.assign({}, constancia);
		let comando="POST";
		 
		constanciaEnvio=JSON.stringify(constanciaEnvio);
		return $.ajax({
			url: getLocacion()+ "/info/validarConstancia",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: constanciaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}  
    
    
     static savaPagoConstancia(pagos ) {          
      let pagosEnvio = Object.assign({}, pagos);
		let comando="POST";
		if (pagosEnvio.id > 0) {
			comando="PUT";			
		} 
		pagosEnvio=JSON.stringify(pagosEnvio);
		return $.ajax({
			url: getLocacion()+ "/info/pagosConstancias",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: pagosEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
}